import { Route } from "@angular/router";

import { ProductDetailComponent } from "./core/components/product-detail/product-detail.component";
import { ProductListComponent } from "./core/components/product-list/product-list.component";
import { CartComponent } from "./core/components/cart/cart.component";
import { HomePageComponent } from "./core/components/home-page/home-page.component";
import { TermsConditionsComponent } from "./core/components/legal/terms-conditions/terms-conditions.component";
import { PrivacyPolicyComponent } from "./core/components/legal/privacy-policy/privacy-policy.component";
import { PricelistsPageComponent } from "./core/components/pricelists-page/pricelists-page.component";
import { LimitedOffersComponent } from "./core/components/limited-offers/limited-offers.component";
import { BrandsPageComponent } from "./core/components/brands-page/brands-page.component";
import { AccountGuard } from "./account/providers/account.guard";
import { SUPPLY_TYPE } from "./shared/constants/pricelist.constants";

export const routes: Route[] = [
    {
        path: "lists",
        canActivate: [AccountGuard],
        loadComponent: () => import("./core/components/list-page/my-lists.component").then(m => m.MyListsComponent),
    },
    {
        path: "lists/:id",
        canActivate: [AccountGuard],
        loadComponent: () => import("./core/components/list-page/list-page.component").then(m => m.ListPageComponent),
    },
    {
        path: "",
        component: HomePageComponent,
        pathMatch: "full",
    },
    {
        path: "brands",
        component: BrandsPageComponent,
    },
    {
        path: "brands/:brandSlug",
        component: ProductListComponent,
    },
    {
        path: "category/:slug",
        component: ProductListComponent,
        pathMatch: "full",
    },
    {
        path: "category/:slug/:supplierId",
        component: ProductListComponent,
        pathMatch: "full",
    },
    {
        path: "search",
        component: ProductListComponent,
    },
    {
        path: "consolidated-feed",
        component: ProductListComponent,
        data: { consolidatedFeed: true },
    },
    {
        path: "product/:slug",
        component: ProductDetailComponent,
    },
    {
        path: "product/:slug/:supplierId",
        component: ProductDetailComponent,
    },
    {
        path: "cart",
        component: CartComponent,
    },
    {
        path: "pricelists/pre-order",
        component: PricelistsPageComponent,
        data: { type: SUPPLY_TYPE.PRE_ORDER },
    },
    {
        path: "pricelists/short-offer",
        component: LimitedOffersComponent,
    },
    {
        path: "limited-offers",
        redirectTo: "pricelists/short-offer",
        pathMatch: "full",
    },
    {
        path: "pricelists/:type",
        component: PricelistsPageComponent,
        canActivate: [AccountGuard],
    },
    {
        path: "terms",
        component: TermsConditionsComponent,
    },
    {
        path: "privacy",
        component: PrivacyPolicyComponent,
    },
    {
        path: "account",
        loadChildren: () =>
            import("./account/account.module").then((m) => m.AccountModule),
    },
    {
        path: "checkout",
        loadChildren: () =>
            import("./checkout/checkout.module").then((m) => m.CheckoutModule),
    },
    {
        path: "seller",
        canActivate: [AccountGuard],
        loadChildren: () =>
            import("./seller/seller.module").then((m) => m.SellerModule),
    },
];
